import { useCallback, useState } from 'react'
import { useTranslations } from '@/core/translation'

/**
 * Parameters accepted by the {@link useSubscribe} stub's `onSubscribe` handler.
 */
export interface SubscribeParams {
  data: {
    email: string
    performerPage?: string
  }
}

/**
 * Minimal fallback for the Next.js app's newsletter subscribe hook.
 *
 * The original wires `@/redux/newsletter` (RTK Query mutation) and
 * `@/core/emailAnalytics`, neither of which is migrated to this SPA yet. This
 * stub preserves the public interface so the Footer newsletter form compiles
 * and behaves gracefully; replace the no-op `onSubscribe` with the real
 * newsletter mutation once `@/redux/newsletter` is ported.
 */
const useSubscribe = () => {
  const [subscribeMessage, setSubscribeMessage] = useState('')
  const t = useTranslations('newsletter')

  const onSubscribe = useCallback(
    async (_params: SubscribeParams) => {
      setSubscribeMessage(t('subscribeSuccess'))
    },
    [t],
  )

  const closeSubscribeModal = useCallback(() => {
    setSubscribeMessage('')
  }, [])

  return {
    onSubscribe,
    isLoading: false,
    subscribeMessage,
    closeSubscribeModal,
  }
}

export default useSubscribe
